<template>
  <b-card
    v-if="warnings.length"
    id="staff-hours-warnings"
  >
    <b-card-header>
      <h4 class="mb-0">
        <feather-icon
          icon="AlertTriangleIcon"
          size="20"
          class="mr-50"
        />
        {{ $t('staffHours.warnings.title') }}
      </h4>
      <b-button
        v-if="rowKey"
        size="sm"
        variant="outline-secondary"
        @click="$emit('clear-filter')"
      >
        {{ $t('staffHours.warnings.resetFilter') }}
      </b-button>
    </b-card-header>
    <b-card-body>
      <div
        v-for="g in groups"
        :key="g.type"
        class="mb-1"
      >
        <h6>{{ g.label }} ({{ g.items.length }})</h6>
        <small
          v-if="g.type === 'open_clocking'"
          class="text-muted d-block mb-50"
        >
          {{ $t('staffHours.warnings.openClockingHint') }}
        </small>
        <div
          v-for="(w, i) in g.items"
          :key="i"
        >
          {{ w.name }} · {{ formatDate(w.date) }} · {{ w.detail }}
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BButton, BCard, BCardBody, BCardHeader,
} from 'bootstrap-vue'

const TYPES = ['open_clocking', 'unlinked_hubstaff', 'work_on_absence', 'unknown_absence_type']

export default {
  components: {
    BButton, BCard, BCardBody, BCardHeader,
  },
  props: {
    warnings: { type: Array, required: true },
    rowKey: { type: String, default: null },
  },
  computed: {
    groups() {
      const list = this.rowKey ? this.warnings.filter(w => w.row_key === this.rowKey) : this.warnings
      return TYPES
        .map(type => ({ type, label: this.$t(`staffHours.warnings.${type}`), items: list.filter(w => w.type === type) }))
        .filter(g => g.items.length)
    },
  },
  methods: {
    formatDate(iso) {
      if (!iso) return ''
      const [, m, d] = iso.split('-')
      return `${d}.${m}.`
    },
  },
}
</script>
